import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { AnimatePresence } from "framer-motion";
import "./App.css";
import SessionGuard from "./services/SessionGuard";

import Login from "./components/features/login";
import Intro from "../src/components/informative/Intro";
import ThankYou from "../src/components/informative/ThankYouPage";
import Instructions from "./components/informative/Instructions";
import ZoomSession from "./components/features/ZoomSession";
import VideosPage from "./components/informative/VideoPage/VideosPage.jsx";

function App() {
  // These would likely come from user input or app state
  const sessionName = "candidate-presentation-123"; // Unique session identifier
  const userName = "CandidateX"; // Candidate's display name
  // A unique ID for the user, e.g., from your database or a generated UUID
  const userIdentity = `candidate_${Date.now()}`;

  return (
    <AnimatePresence mode="wait">
      <Router>
        <Routes location={window.location} key={window.location.pathname}>
          <Route path="/" element={<Login />} />
          <Route
            path="/intro"
            element={
              <SessionGuard>
                <Intro />
              </SessionGuard>
            }
          />
          <Route
            path="/instructions"
            element={
              <SessionGuard>
                <Instructions />
              </SessionGuard>
            }
          />
          <Route path="/videos" element={<VideosPage />} />
          <Route path="/thank-you" element={<ThankYou />} />
          <Route
            path="/recording"
            element={
              <SessionGuard>
                <ZoomSession
                  sessionName={sessionName}
                  userName={userName}
                  userIdentity={userIdentity}
                />
              </SessionGuard>
            }
          />
        </Routes>
      </Router>
    </AnimatePresence>
  );
}

export default App;
